import { render, staticRenderFns } from "./public.vue?vue&type=template&id=f7788522"
import script from "./public.vue?vue&type=script&lang=ts"
export * from "./public.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports